import requestFunctions from "../../functions/requestFunctions";


export const state = {

  DIALOGS_ITEM: {
    'uuid' : null,
    'json_data'  : null,
    'created_at' : null,
    'updated_at' : null,
    'deleted_at' : null
  },
  DIALOGS_LIST: [],

  DIALOGS_TABLE_DATA: [],
  DIALOGS_LIST_DATA: [],

}

export const getters = {

  GET_DIALOGS_ITEM: (state) => {
    return state.DIALOGS_ITEM;
  },
  GET_DIALOGS_LIST: (state) => {
    return state.DIALOGS_LIST;
  },
  GET_DIALOGS_TABLE_DATA: (state) => {
    return state.DIALOGS_TABLE_DATA;
  },
  GET_DIALOGS_LIST_DATA: (state) => {
    return state.DIALOGS_LIST_DATA;
  },
  
}

export const mutations = {
  UPDATE_DIALOGS_ITEM(state, item) {
    state.DIALOGS_ITEM = item;
  },
  UPDATE_DIALOGS_LIST(state, list) {

    state.DIALOGS_LIST = list;
    state.DIALOGS_TABLE_DATA = [];
    state.DIALOGS_LIST_DATA = [];

    list.forEach(el => {

      let status = '';

      if(el.status === 'active'){
        status = 'Активен'
      }
      if(el.status === 'wait'){
        status = 'Ожидает ответа'
      }
      if(el.status === 'answered'){
        status = 'Отвечено'
      }
      if(el.status === 'archive'){
        status = 'Архив'
      }

      let fullname = '';

      if(el.customer && el.customer.profile){
        if (el.customer.profile.name1) { fullname = fullname + el.customer.profile.name1 + ' '; }
        if (el.customer.profile.name2) { fullname = fullname + el.customer.profile.name2 + ' '; }
        if (el.customer.profile.name3) { fullname = fullname + el.customer.profile.name3 + ' '; }
      }

      state.DIALOGS_TABLE_DATA.push({
        'id' : el.id,
        'customer' : fullname,
        'qnt_messages' : el.qnt_messages ? el.qnt_messages : 0,
        'channel' : el.channel && el.channel.name ? el.channel.name : '',
        'last_activity_at' : el.last_activity_at ? el.last_activity_at : '',
        'created_at' : el.created_at_f ? el.created_at_f : '',
        'status' : status,
        'uuid' : el.uuid
      });

    });
  },
}

export const actions = {

  async FETCH_DIALOGS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_DIALOGS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_DIALOGS_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_DIALOGS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_DIALOGS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_DIALOGS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_DIALOGS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}